import { ToolHUDItem, toolTypeToUIData } from "@/toolHUDItems";
import ToolType from "@/wbcontroller/types/ToolType";
import makeTypeSafeCommitter from "../makeTypeSafeCommitter";

export interface ColorMap {
  artisanal: string[];
  util: string[];
  factory: string[][];
}

export interface RenderConfig {
  defaultLineCap: "butt" | "round" | "square";
}

export interface ToolConfigState {
  colors: ColorMap;
  customColors: [string, string[]][] | null;
  strokeWidths: number[];
  toolTypes: ToolType[];
  renderConfig: RenderConfig;
}

const mutations = {
  configureCustomColors(state: ToolConfigState, colors: [string, string[]][]) {
    state.customColors = colors;
  },

  configureStrokeWidths(state: ToolConfigState, strokeWidths: number[]) {
    state.strokeWidths = strokeWidths;
  },
};
type ToolConfigMutationsWithState = typeof mutations;

export const ToolConfigMutations = makeTypeSafeCommitter<
  ToolConfigState,
  typeof mutations
>(mutations);

const getters = {
  tools(state: ToolConfigState): ToolHUDItem[] {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return state.toolTypes.map((t) => toolTypeToUIData[t]!);
  },
};
type ToolConfigGettersWithState = typeof getters;
export type ToolConfigGetters = {
  [Property in keyof ToolConfigGettersWithState]: ReturnType<
    ToolConfigGettersWithState[Property]
  >;
};

export function makeToolConfigModule(
  colorMap: ColorMap,
  strokeWidths: number[],
  toolTypes: ToolType[],
  renderConfig: RenderConfig | null = null
): {
  state: () => ToolConfigState;
  mutations: ToolConfigMutationsWithState;
  getters: ToolConfigGettersWithState;
} {
  return {
    state: () => ({
      colors: colorMap,
      customColors: null,
      strokeWidths,
      toolTypes,
      renderConfig: renderConfig || {
        defaultLineCap: "round",
      },
    }),
    mutations,
    getters,
  };
}
